import {TicketBuyResultVo} from '../../common/shared/api/nicolas/vo/TicketBuyResultVo.interface';
import {TicketBuyMutationPayload} from '../generated/types';

export function createTicketBuyMutationPayload({
  remain_cash,
  buy_ticketinfo,
}: TicketBuyResultVo): TicketBuyMutationPayload {
  return {
    remainCash: remain_cash,
    purchasedTicketCount: buy_ticketinfo,
  };
}
